import React, {useState, useEffect, useRef} from 'react'
import Icon from 'components/utils/Icon'
import IconAndText from 'components/utils/IconAndText'
import CircleButton from 'components/utils/CircleButton'
import SquareButton from 'components/utils/SquareButton'
import AddButton from 'components/utils/AddButton'
import Modal from 'components/utils/Modal'
import SearchBar from 'components/utils/SearchBar'
import DailyDescription from 'components/menu/DailyDescription'
import EquipDescription from 'components/menu/EquipDescription'
import Sign from 'components/utils/Sign'
import Job from 'components/menu/Job'

import { getDayName, formatDateYMD, formatDateTime, getLocation, catchError, replaceStr, filterData, addActivity } from 'scripts/common'

import { createPDF } from 'scripts/pdf'

import { jsPDF } from "jspdf";

const Dailies = (props) => {

  const path = `dailies/daily`

  const googleRef = useRef(null)
  const mapRef = useRef(null)
  const markerRef = useRef([])

  const [fetchedData, setFetchedData] = useState([])
  const [fetchedTasks, setFetchedTasks] = useState([])

  const [isModal, setIsModal] = useState({
    add: false,
    edit: false,
    menu: false,
    sign: false,
    google: false,
    preview: false,
    warning: 0,
    warningContent: '',
    description: false,
    equipment: false,
    loading: true,
    saving: false,
    job: false
  })

  const [isTask, setIsTask] = useState({
    second: false,
    third: false,
    fourth: false
  })

  const isChanged = useRef(false)
  const [isUnsignedDailies, setIsUnsignedDailies] = useState(false)
  const [isGoogleMap, setIsGoogleMap] = useState(false)
  const [searchValue, setSearchValue] = useState('')

  const fileArray = useRef([])
  const canvasSign = useRef(null)
  const signaturePad = useRef(null) // old. created separate component
  //const receivedBySignature = useRef(null)
  const descriptionPosition = useRef(null)
  const equipmentPosition = useRef(null)

  const [isValidated, setIsValidated] = useState({
    entryby: '',
    entrytime: null,
    entrylat: '',
    entrylng: '',
    entrydevice: '',
    modby: '',
    modtime: null,
    modlat: '',
    modlng: '',
    moddevice: '',
    completeby: '',
    completetime: null,
    signby: '',
    signtime: null,
    signlat: '',
    signlng: '',
    id: null,
    jobNumber: '',
    gradeId: '',
    dailiesType: '',
    memoNo: null,
    dailiesDate: '',
    contractor: '',
    foreman: '',
    equipment: '',
    description: '',
    weather: '',
    yardageToday: '',
    yardageToDate: '',
    permitNo: '',
    jurisdiction: '',
    inspectorId: '',
    receivedBy: '',
    distribution: '',
    taskCode1: '',
    hours1: '',
    taskCode2: '',
    hours2: '',
    taskCode3: '',
    hours3: '',
    taskCode4: '',
    hours4: '',
    dailiesStatus: 'Incomplete'
  })

  const clearIsValidated = () => setIsValidated({
    entryby: '',
    entrytime: null,
    entrylat: '',
    entrylng: '',
    entrydevice: '',
    modby: '',
    modtime: null,
    modlat: '',
    modlng: '',
    moddevice: '',
    completeby: '',
    completetime: null,
    signby: '',
    signtime: null,
    signlat: '',
    signlng: '',
    id: null,
    gradeId: '',
    dailiesType: '',
    memoNo: null,
    dailiesDate: '',
    contractor: '',
    foreman: '',
    equipment: '',
    description: '',
    weather: '',
    yardageToday: '',
    yardageToDate: '',
    permitNo: '',
    jurisdiction: '',
    inspectorId: '',
    receivedBy: '',
    distribution: '',
    taskCode1: '',
    hours1: '',
    taskCode2: '',
    hours2: '',
    taskCode3: '',
    hours3: '',
    taskCode4: '',
    hours4: '',
    dailiesStatus: 'Incomplete'
  })

  async function fetchDailies() {

    let response = await fetch('/api/selectManageDailies', {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        filter: props.filter
      })
    })
    return response.json();

  }

  const fetchData = () => {

    fetchDailies()
    .then(
      (result) => {
        //console.log('fetching data...')
        //console.log('result: ' + JSON.stringify(result))
        //setFetchedData(result)

        setFetchedData(result.map(data => (
          {...data,
            entrytime: data.entrytime !== null ? formatDateTime(data.entrytime) : data.entrytime,
            modtime: data.modtime !== null ? formatDateTime(data.modtime) : data.modtime,
            dailiesdate: formatDateYMD(data.dailiesdate)
          }
        )))

        setIsModal(prevState => ({...prevState, loading: false}))
      },
      (error) => {
        catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'selectDailies', JSON.stringify(error), props.user.username, props.user.device)
      }
    )   

    fetch('/api/selectDailyTasks', {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        gradeId: props.filter.gradeId
      })
    })
    .then(res=>res.json())
    .then(
      (result) => {
        console.log('result task: ' + JSON.stringify(result))
        setFetchedTasks(result)
      },
      (error) => {
        catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'selectDailyTasks', JSON.stringify(error), props.user.username, props.user.device)
      }
    )

  }

  useEffect(() => {
    if (isModal.google) initMap()
  }, [props.filter, isModal.google, fetchedData])

  useEffect(() => {
    if (isModal.google) updateMap()
  }, [searchValue, isModal.google, fetchedData])

  useEffect(() => {fetchData()
  }, [props.filter])

  // useEffect(() => {
  //
  //   // On mobile devices it might make more sense to listen to orientation change,
  //   // rather than window resize events.
  //
  //   if (isModal.sign) {
  //
  //     signaturePad.current = new SignaturePad(canvasSign.current, {
  //       backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
  //     })
  //
  //     window.onresize = resizecanvasSign;
  //     resizecanvasSign() // necessary to allow signing
  //
  //   }
  //
  // }, [isModal.sign])

  // Sets the map on all markers in the array.
  const hightlightMarker = (e) => {

    let id = parseInt(e.target.parentNode.getAttribute('data-id'))

    for (let i = 0; i < markerRef.current.length; i++) {
      if (markerRef.current[i].get("id") === id) {

        markerRef.current[i].setIcon('http://maps.google.com/mapfiles/ms/icons/yellow-dot.png')
        markerRef.current[i].setAnimation(window.google.maps.Animation.BOUNCE)
      } else {

        markerRef.current[i].setIcon('http://maps.google.com/mapfiles/ms/icons/blue-dot.png')
        markerRef.current[i].setAnimation(null)
        markerRef.current[i].getVisible(false)
      }

      markerRef.current[i].setMap(mapRef.current);
    }
  }

  const updateMap = (id, visible) => {

    for (let i = 0; i < markerRef.current.length; i++) {
      if (markerRef.current[i].get("id") === id) {

        markerRef.current[i].setVisible(visible)

      }

      markerRef.current[i].setMap(mapRef.current);
    }
  }

  const initMap = () => {

    let data = fetchedData.filter(data => {

      if (data.entrylat !== '' && data.entrylat !== null && data.entrylng !== '' && data.entrylng !== null) {

        let description = data.description === null ? '' : data.description
        let status = data.dailiesstatus === null ? '' : data.dailiesstatus
        let dailiesDate = data.dailiesdate === null ? '' : data.dailiesdate
        let entryBy = data.entryby !== null && data.entryby !== '' ? data.entryby : '?'
        let entryTime = data.entrytime === null ? '' : data.entrytime

        return true

      }

      return false


    })

    let google = googleRef.current

    mapRef.current = new window.google.maps.Map(google, {
         mapTypeId: window.google.maps.MapTypeId.ROADMAP
    });

    let infoWindow = new window.google.maps.InfoWindow;

    let marker, i, latLng, pre, number, suf, testNo

    //let i, latLng

    let bounds = new window.google.maps.LatLngBounds();

    //console.log(`locations: ${JSON.stringify(data)}`)

    for (i = 0; i < data.length; i++) {

      // pre = data[i].pre === null ? '' : data[i].pre
      // number = data[i].testno === null ? '' : data[i].testno
      // suf = data[i].suf === null ? '' : data[i].suf
      // testNo = `${pre} ${number} ${suf}`

      let dailiesDate = data[i].dailiesdate === null ? '' : data[i].dailiesdate
      let entryBy = data[i].entryby !== null && data[i].entryby !== '' ? data[i].entryby : '?'

      marker = new window.google.maps.Marker({
        position: new window.google.maps.LatLng(data[i].entrylat, data[i].entrylng),
        title: `${entryBy} - ${dailiesDate}`,
        animation: window.google.maps.Animation.DROP,
        map: mapRef.current,
        icon: {
          url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
        },
        id: data[i].id,
        visible: filterData(data[i], searchValue)
      });

      marker.setMap(mapRef.current)

      markerRef.current.push(marker)

      latLng = new window.google.maps.LatLng(data[i].entrylat, data[i].entrylng);

      bounds.extend(latLng);

      window.google.maps.event.addListener(marker, 'click', function () {
        infoWindow.setContent('<h3>' + this.title + '</h3>');
        infoWindow.open(mapRef.current, this);
      });

    }

    mapRef.current.fitBounds(bounds);

    mapRef.current.setCenter(bounds.getCenter());

  }

  const validate = (event) => {
    let name = event.target.getAttribute('name')
    let state = event.target.reportValidity()
    let type = event.target.type
    let value = type === 'checkbox' ? event.target.checked : event.target.value

    event.target.style.backgroundColor = state ? 'white' : 'yellow'

    setIsValidated(prevState => ({...prevState, [name]: state ? value : null}))
  }

  const changedData = () => isChanged.current = true

  const selectRow = (e) => {

    let tr = e.currentTarget
    let td = tr.getElementsByTagName('td')
    let i = tr.getAttribute('data-i')

    if (i === '' || i === null) {
      alert('Error: data i not found. Contact an admin.')
    } else {

      // check for warning => 0: can edit/delete, 1: can edit, 2: cannot edit/delete
      let today = new Date()
      let entry = new Date(fetchedData[i].entrytime)
      let timeDiff = Math.abs(entry.getTime() - today.getTime())
      let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) // 1 day

      if (props.user.daily < 2) {

        setIsModal(prevState => ({...prevState, warning: 2, warningContent: 'Cannot Edit/Delete: You do not have required permission. Contact an Admin.'}))

      } else if ((props.user.daily === 2 || props.user.daily === 3) && props.user.username !== fetchedData[i].entryby) {

        setIsModal(prevState => ({...prevState, warning: 2, warningContent: `Cannot Edit/Delete: ${fetchedData[i].entryby} is the owner.`}))

      // } else if ((props.user.daily === 2 || props.user.daily === 3) && props.user.username === fetchedData[i].entryby && diffDays > 1) {
      //
      //   setIsModal(prevState => ({...prevState, warning: 2, warningContent: `Cannot Edit/Delete: Time has elasped (24 hrs). Contact a Manager`}))

      } else if ((props.user.daily === 2 || props.user.daily === 3) && props.user.username !== fetchedData[i].entryby && fetchedData[i].dailiesstatus === 'Complete') {

        setIsModal(prevState => ({...prevState, warning: 2, warningContent: 'Cannot Edit/Delete: This daily is Complete. Contact a Manager.'}))

      } else if (props.user.daily < 5 && fetchedData[i].dailiesstatus === 'Signed') {

        setIsModal(prevState => ({...prevState, warning: 2, warningContent: 'Cannot Edit/Delete: This daily is signed. Contact a Manager.'}))

      // allow managers with add/edit permission to delete incompete/complete dailies

      // } else if (props.user.daily === 4) {
      //
      //   setIsModal(prevState => ({...prevState, warning: 1, warningContent: `Cannot Delete: You do not have required permission. Contact an Admin.`}))

      } else {

        setIsModal(prevState => ({...prevState, warning: 0, warningContent: ``}))

      }

      // can probably remove memoNo and dailiesType

      setIsValidated(prevState => ({...prevState,
        entryby: fetchedData[i].entryby,
        entrytime: fetchedData[i].entrytime,
        entrylat: fetchedData[i].entrylat,
        entrylng: fetchedData[i].entrylng,
        entrydevice: fetchedData[i].entrydevice,
        modby: fetchedData[i].modby,
        modtime: fetchedData[i].modtime,
        modlat: fetchedData[i].modlat,
        modlng: fetchedData[i].modlng,
        moddevice: fetchedData[i].moddevice,
        id: fetchedData[i].id,
        jobNumber: fetchedData[i].jobnumber,
        gradeId: fetchedData[i].gradeid,
        dailiesType: fetchedData[i].dailiestype,
        memoNo: fetchedData[i].memono,
        dailiesDate: fetchedData[i].dailiesdate,
        contractor: fetchedData[i].contractor,
        foreman: fetchedData[i].foreman,
        equipment: fetchedData[i].equipment,
        description: fetchedData[i].description,
        weather: fetchedData[i].weather,
        yardageToday: fetchedData[i].yardagetoday,
        yardageToDate: fetchedData[i].yardagetodate,
        permitNo: fetchedData[i].permitNo,
        jurisdiction: fetchedData[i].jurisdiction,
        inspectorId: fetchedData[i].inspectorId,
        receivedBy: fetchedData[i].receivedby,
        taskCode1: fetchedData[i].taskcode1,
        hours1: fetchedData[i].hours1,
        taskCode2: fetchedData[i].taskcode2,
        hours2: fetchedData[i].hours2,
        taskCode3: fetchedData[i].taskcode3,
        hours3: fetchedData[i].hours3,
        taskCode4: fetchedData[i].taskcode4,
        hours4: fetchedData[i].hours4,
        dailiesStatus: fetchedData[i].dailiesstatus,
        completeBy: fetchedData[i].completeby,
        completeTime: fetchedData[i].completetime
      }))

      if (!isModal.preview) openEdit()

    }

  }

  const selectDailyDescription = (e) => {

    let tr = e.target.parentNode
    let td = tr.getElementsByTagName('td')
    let description
    let addDescription = td[0].textContent

    if (descriptionPosition.current !== null) {

      if (isValidated.description !== '' && isValidated.description !== null) {

        description = [isValidated.description.slice(0, descriptionPosition.current), addDescription, isValidated.description.slice(descriptionPosition.current)].join('')

      } else {

        description = addDescription

      }

      setIsValidated(prevState => ({...prevState,
        description: description
      }))

      changedData()

    } else {
      alert('Select a position in your description to add new text.')
    }

    closeDescription()

  }

  const selectEquipDescription = (e) => {

    let tr = e.target.parentNode
    let td = tr.getElementsByTagName('td')
    let equipment
    let addEquipment = td[0].textContent

    if (equipmentPosition.current !== null) {

      if (isValidated.equipment !== '' && isValidated.equipment !== null) {

        equipment = [isValidated.equipment.slice(0, equipmentPosition.current), addEquipment, isValidated.equipment.slice(equipmentPosition.current)].join('')

      } else {

        equipment = addEquipment

      }

      setIsValidated(prevState => ({...prevState,
        equipment: equipment
      }))

      changedData()

    } else {
      alert('Select a position in your equipment to add new text.')
    }

    closeEquipment()

  }

  const addDaily = () => {

    if (props.user.daily < 2) {
      alert('You do not have the required permission. Contact an admin.')
    } else if (isValidated.dailiesDate === null || isValidated.dailiesDate ==='') {
      alert("Please select a Date.");
    } else if (isValidated.dailiesType === null || isValidated.dailiesType ==='') {
      alert("Please select a Type.");
    } else if ((isValidated.dailiesStatus === 'Complete' && isValidated.dailiesType === 'inspector') && (isValidated.permitNo === null || isValidated.permitNo ==='')) {
      alert("Please provide a Permit No.");
    } else if ((isValidated.dailiesStatus === 'Complete' && isValidated.dailiesType === 'inspector') && (isValidated.jurisdiction === null || isValidated.jurisdiction ==='')) {
      alert("Please provide a Jurisdiction.");
    } else if ((isValidated.dailiesStatus === 'Complete' && isValidated.dailiesType === 'inspector') && (isValidated.inspectorId === null || isValidated.inspectorId ==='')) {
      alert("Please provide a Inspector ID.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.contractor === null || isValidated.contractor ==='')) {
      alert("Please provide a Contractor.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.foreman === null || isValidated.foreman ==='')) {
      alert("Please provide a Foreman.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.weather === null || isValidated.weather ==='')) {
      alert("Please select the Weather.");
    } else  if (isValidated.dailiesStatus === 'Complete' && (isValidated.equipment === null || isValidated.equipment ==='')) {
      alert("Please provide Equipment used.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.description === null || isValidated.description ==='')) {
      alert("Please provide a Description of the work.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.taskCode1 === null || isValidated.taskCode1 ==='')) {
      alert("Please select at least 1 task.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.hours1 === null || isValidated.hours1 ==='')) {
      alert("Please provide your hours.");
    } else {

      // include optd and optm???

      getLocation(function(latlng){

        fetch('/api/addDaily', {
          method: 'post',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            by: props.user.username,
            time: formatDateTime(new Date()),
            lat: latlng.lat,
            lng: latlng.lng,
            device: props.user.device,
            jobnumber: props.filter.jobNumber,
            gradeid: props.filter.gradeId,
            dailiesdate: isValidated.dailiesDate,
            dailiestype: isValidated.dailiesType,
            contractor: replaceStr(isValidated.contractor),
            foreman: replaceStr(isValidated.foreman),
            weather: isValidated.weather,
            yardagetoday: isValidated.yardageToday,
            yardagetodate: isValidated.yardageToDate,
            permitNo: isValidated.permitNo,
            jurisdiction: isValidated.jurisdiction,
            inspectorId: isValidated.inspectorId,
            equipment: replaceStr(isValidated.equipment),
            description: replaceStr(isValidated.description),
            taskcode1: isValidated.taskCode1,
            taskcode2: isValidated.taskCode2,
            taskcode3: isValidated.taskCode3,
            taskcode4: isValidated.taskCode4,
            hours1: isValidated.hours1,
            hours2: isValidated.hours2,
            hours3: isValidated.hours3,
            hours4: isValidated.hours4,
            dailiesstatus: isValidated.dailiesStatus
          })
        })
        .then(res=>res.json())
        .then(result => {
            //console.log('result: ' + JSON.stringify(result[0].lastId))

            addActivity('field', props.filter.jobNumber, props.filter.gradeId, props.component, 'add', `Daily ${isValidated.dailiesDate}`, props.user.username)

            fetchDailies()
            .then(
              (res) => {
                //console.log('fetching data...')
                //console.log('result: ' + result)

                //let data = res.find(data => data.id === result[0].lastId)

                // if (data === undefined) {
                //   alert('Error: daily id not found. Could not PDF.')
                // } else {
                  //createPDF(data, 'add')
                  createPDF(result[0].lastId, res, 'add', props.user, '')
                //}

                //setFetchedData(res)
                setFetchedData(res.map(data => (
                  {...data,
                    entrytime: data.entrytime !== null ? formatDateTime(data.entrytime) : data.entrytime,
                    modtime: data.modtime !== null ? formatDateTime(data.modtime) : data.modtime,
                    dailiesdate: formatDateYMD(data.dailiesdate)
                  }
                )))
              },
              (error) => {
                catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'selectDailies', JSON.stringify(error), props.user.username, props.user.device)
              }
            )

            //fetchData() // i need the id if edited
            isChanged.current = false
            closeModal()
            //alert('Added.')

          },
          (error) => {

            alert('Error: could not add daily. Contact and admin.')
            catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'addDaily', JSON.stringify(error), props.user.username, props.user.device)
          }
        )

      })

    }

  }

  const editDaily = () => {

    //console.log('edit?')

    // if (props.user.daily < 2) {
    //   alert('You do not have the required permission. Contact an admin.')
    if (isModal.warning > 1) {
      alert('You do not have the required permission. Contact an admin.')
    } else if (isChanged.current === false) {
      alert('Nothing has been changed.')
    } else if (isValidated.jobNumber === null || isValidated.jobNumber === '') {
      alert("Please select a Jobnumber.");
    } else if (isValidated.gradeId === null || isValidated.gradeId === '') {
      alert("Please select grading or post.");
    } else if (isValidated.dailiesDate === null || isValidated.dailiesDate ==='') {
      alert("Please select a Date.");
    } else if (isValidated.dailiesType === null || isValidated.dailiesType ==='') {
      alert("Please select a Type.");
    } else if ((isValidated.dailiesStatus === 'Complete' && isValidated.dailiesType === 'inspector') && (isValidated.permitNo === null || isValidated.permitNo ==='')) {
      alert("Please provide a Permit No.");
    } else if ((isValidated.dailiesStatus === 'Complete' && isValidated.dailiesType === 'inspector') && (isValidated.jurisdiction === null || isValidated.jurisdiction ==='')) {
      alert("Please provide a Jurisdiction.");
    } else if ((isValidated.dailiesStatus === 'Complete' && isValidated.dailiesType === 'inspector') && (isValidated.inspectorId === null || isValidated.inspectorId ==='')) {
      alert("Please provide a Inspector ID.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.contractor === null || isValidated.contractor ==='')) {
      alert("Please provide a Contractor.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.foreman === null || isValidated.foreman ==='')) {
      alert("Please provide a Foreman.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.weather === null || isValidated.weather ==='')) {
      alert("Please select the Weather.");
    } else  if (isValidated.dailiesStatus === 'Complete' && (isValidated.equipment === null || isValidated.equipment ==='')) {
      alert("Please provide Equipment used.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.description === null || isValidated.description ==='')) {
      alert("Please provide a Description of the work.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.taskCode1 === null || isValidated.taskCode1 ==='')) {
      alert("Please select at least 1 task.");
    } else if (isValidated.dailiesStatus === 'Complete' && (isValidated.hours1 === null || isValidated.hours1 ==='')) {
      alert("Please provide your hours.");
    } else {

      // include optd and optm???

      getLocation(function(latlng){

        fetch('/api/editDaily', {
          method: 'post',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            by: props.user.username,
            time: formatDateTime(new Date()),
            lat: latlng.lat,
            lng: latlng.lng,
            device: props.user.device,
            id: isValidated.id,
            jobNumber: isValidated.jobNumber,
            gradeId: isValidated.gradeId,
            dailiesdate: isValidated.dailiesDate,
            dailiestype: isValidated.dailiesType,
            contractor: replaceStr(isValidated.contractor),
            foreman: replaceStr(isValidated.foreman),
            weather: isValidated.weather,
            yardagetoday: isValidated.yardageToday,
            yardagetodate: isValidated.yardageToDate,
            permitNo: isValidated.permitNo,
            jurisdiction: isValidated.jurisdiction,
            inspectorId: isValidated.inspectorId,
            equipment: replaceStr(isValidated.equipment),
            description: replaceStr(isValidated.description),
            taskcode1: isValidated.taskCode1,
            taskcode2: isValidated.taskCode2,
            taskcode3: isValidated.taskCode3,
            taskcode4: isValidated.taskCode4,
            hours1: isValidated.hours1,
            hours2: isValidated.hours2,
            hours3: isValidated.hours3,
            hours4: isValidated.hours4,
            dailiesstatus: isValidated.dailiesStatus,
            completeby: isValidated.completeby
          })
        })
        .then(res=>res.json())
        .then(
          (result) => {
            addActivity('field', props.filter.jobNumber, props.filter.gradeId, props.component, 'edit', `Daily ${isValidated.dailiesDate}`, props.user.username)

            // quick solution for createPDF()

            fetchDailies()
            .then(
              (result) => {
                //console.log('fetching data...')
                //console.log('result: ' + result)

                //let data = result.find(data => data.id === isValidated.id)

                // if (data === undefined) {
                //   alert('Error: daily id not found. Could not PDF.')
                // } else {
                  //createPDF(data, 'edit')
                  createPDF(isValidated.id, result, 'edit', props.user, '')
                //}

                //setFetchedData(result)
                setFetchedData(result.map(data => (
                  {...data,
                    entrytime: data.entrytime !== null ? formatDateTime(data.entrytime) : data.entrytime,
                    modtime: data.modtime !== null ? formatDateTime(data.modtime) : data.modtime,
                    dailiesdate: formatDateYMD(data.dailiesdate)
                  }
                )))
              },
              (error) => {
                catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'selectDailies', JSON.stringify(error), props.user.username, props.user.device)
              }
            )

            isChanged.current = false
            closeModal()
            //alert('Updated')

          },
          (error) => {

            alert('Error: could not edit daily. Contact and admin.')
            catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'editDaily', JSON.stringify(error), props.user.username, props.user.device)
          }
        )

      })

    }

  }

  const viewDaily = () => window.open(`${path}${isValidated.id}.pdf`)

  const signDaily = (signature, receivedBy) => {

    // Returns true if canvas is empty, otherwise returns false
    // if (signaturePad.current.isEmpty()) {
    //   alert('Please provide a signature.')
    // } else if (isValidated.receivedBy === null || isValidated.receivedBy === '') {
    //   alert('Please provide your full name.')
    // } else {

      //receivedBySignature.current = signature

      getLocation(function(latlng) {

        fetch('/api/signDaily', {
          method: 'post',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            by: props.user.username,
            time: formatDateTime(new Date()),
            lat: latlng.lat,
            lng: latlng.lng,
            id: isValidated.id,
            signature: signature,
            receivedBy: receivedBy,
            dailiesStatus: 'Signed'
          })
        })
        .then(res=>res.json())
        .then(
          (result) => {
            //console.log('result: ' + JSON.stringify(result))

            addActivity('field', props.filter.jobNumber, props.filter.gradeId, props.component, 'sign', `Daily ${isValidated.dailiesDate}`, props.user.username)

            fetchDailies()
            .then(
              (result) => {
                //console.log('fetching data...')
                //console.log('result: ' + result)

                //let data = result.find(data => data.id === isValidated.id)

                // if (data === undefined) {
                //   alert('Error: daily id not found. Could not PDF.')
                // } else {
                  //createPDF(data, 'sign')
                  createPDF(isValidated.id, result, 'sign', props.user, signature)
                //}

                //setFetchedData(result)
                setFetchedData(result.map(data => (
                  {...data,
                    entrytime: data.entrytime !== null ? formatDateTime(data.entrytime) : data.entrytime,
                    modtime: data.modtime !== null ? formatDateTime(data.modtime) : data.modtime,
                    dailiesdate: formatDateYMD(data.dailiesdate)
                  }
                )))
              },
              (error) => {
                catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'selectDailies', JSON.stringify(error), props.user.username, props.user.device)
              }
            )

            isChanged.current = false
            closeModal()

          },
          (error) => {

            alert('Error: could not sign daily. Contact and admin.')
            catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'signDaily', JSON.stringify(error), props.user.username, props.user.device)
          }
        )

      })

    //}

  }

  const deleteDaily = () => {

    // if (props.user.daily < 3) {
    //   alert('You do not have the required permission. Contact an admin.')
    if (isModal.warning > 0) {
      alert('You do not have the required permission. Contact an admin.')
    } else {

      if (window.confirm('If you proceed, this will be deleted. Proceed?')) {

        //let i = fetchedDataIndex.current

        fetch('/api/deleteDaily', {
          method: 'post',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: isValidated.id,
            path: `${path}${isValidated.id}.pdf`
          })
        })
        .then(res=>res.json())
        .then(
          (result) => {
            //console.log('result: ' + result)

            addActivity('field', props.filter.jobNumber, props.filter.gradeId, props.component, 'delete', `Daily ${isValidated.dailiesDate}`, props.user.username)

            setFetchedData(fetchedData.filter(data => data.id !== isValidated.id))
            isChanged.current = false
            closeModal()

          },
          (error) => {
            catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'deleteDaily', JSON.stringify(error), props.user.username, props.user.device)
          }
        )

      }

    }

  }

  const downloadDailies = () => {

    fetch('/api/mergeDailies', {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        fileName: `not used`,
        fileArray: fileArray.current
      })
    })
    .then(res=>res.json())
    .then(
      (result) => {
        //console.log('result: ' + result)

        addActivity('field', props.filter.jobNumber, props.filter.gradeId, props.component, 'download', `Dailies`, props.user.username)

        window.open(`dailies.pdf`)

      },
      (error) => {
        alert('Error: could not merge PDFs for download. Contact and admin.')
        catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'mergeDailies', JSON.stringify(error), props.user.username, props.user.device)
      }
    )

  }

  const resizecanvasSign = () => {

    if (document.activeElement.tagName !== 'INPUT') {

      let ratio =  Math.max(window.devicePixelRatio || 1, 1);

      // This part causes the canvas to be cleared
      canvasSign.current.width = canvasSign.current.offsetWidth * ratio;
      canvasSign.current.height = canvasSign.current.offsetHeight * ratio;
      canvasSign.current.getContext("2d").scale(ratio, ratio);

      // This library does not listen for canvas changes, so after the canvas is automatically
      // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
      // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
      // that the state of this library is consistent with visual state of the canvas, you
      // have to clear it manually.
      signaturePad.current.clear()

    }

  }

  const addSignature = () => {

    let signature = signaturePad.current.toDataURL('image/jpeg');

    if (signature === null || signature === '') {

        alert("Signature is blank.");

    } else {

      // signature = signature.replace('data:image/jpeg;base64,', '');
	    // signature = signature.replace(' ', '+');

      getLocation(function(latlng){

        fetch('/api/addSignature', {
          method: 'post',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userId: props.user.userid,
            signature: signature,
            time: formatDateTime(new Date()),
            lat: latlng.lat,
            lng: latlng.lng,
          })
        })
        .then(res=>res.json())
        .then(
          (result) => {
            //console.log('result: ' + result)

            addActivity('field', props.filter.jobNumber, props.filter.gradeId, props.component, 'add Signature', `Daily ${isValidated.dailiesDate}`, props.user.username)

            signaturePad.current.clear()
          },
          (error) => {
            catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'addSignature', JSON.stringify(error), props.user.username, props.user.device)
          }
        )

      })

    }

  }

  const undoSignature = () => signaturePad.current.clear()

  const search = (e) => {
    let value = e.target.value
    setSearchValue(value)
  }

  const clearSearch = () => {
    document.getElementById('searchInput').value = ''
    setSearchValue('')
  }

  const viewUnsignedDailies = () => setIsUnsignedDailies(isUnsignedDailies ? false : true)

  const addTask = () => {
    let task = !isTask.second ? 'second' : !isTask.third ? 'third' : 'fourth'
    //console.log(`task: ${task}`)

    setIsTask(prevState => ({...prevState, [task]: true}))
  }

  const removeTask1 = () => {
    console.log('clicked')
    setIsValidated(prevState => ({...prevState, taskCode1: '', hours1: ''}))
  }

  const removeTask2 = () => {
    setIsTask(prevState => ({...prevState, second: false}))
    setIsValidated(prevState => ({...prevState, taskCode2: '', hours2: ''}))
  }

  const removeTask3 = () => {
    setIsTask(prevState => ({...prevState, third: false}))
    setIsValidated(prevState => ({...prevState, taskCode3: '', hours3: ''}))
  }

  const removeTask4 = () => {
    setIsTask(prevState => ({...prevState, fourth: false}))
    setIsValidated(prevState => ({...prevState, taskCode4: '', hours4: ''}))
  }

  const openAdd = () => {

    if (props.user.daily < 2) {

      alert('You do not have the required permission. Contact an admin.')

    } else if (props.filter.jobNumber === '') {

      alert('Please select a JN.')

    } else {

      setIsModal(prevState => ({...prevState, add: true}))

    }

  }

  const openEdit = () => setIsModal(prevState => ({...prevState, edit: true}))

  const openMenu = () => setIsModal(prevState => ({...prevState, menu: true}))

  const openSign = () => {
    if (isValidated.dailiesStatus === 'Complete') {
      setIsModal(prevState => ({...prevState, sign: true}))
    } else {
      alert('The Daily must be marked Complete to sign.')
    }
  }

  const openDescription = () => setIsModal(prevState => ({...prevState, description: true}))

  const closeDescription = () => setIsModal(prevState => ({...prevState, description: false}))

  const openEquipment = () => {
    alert('Temporarily disabled')
    //setIsModal(prevState => ({...prevState, equipment: true}))
  }

  const closeEquipment = () => setIsModal(prevState => ({...prevState, equipment: false}))

  const closeMenu = () => setIsModal(prevState => ({...prevState, menu: false}))

  const closeSign = () => setIsModal(prevState => ({...prevState, sign: false}))

  const toggleGoogle = () => setIsModal(prevState => ({...prevState, google: isModal.google ? false : true}))

  const togglePreview = () => {
    if (isModal.preview) clearIsValidated()
    setIsModal(prevState => ({...prevState, preview: isModal.preview ? false : true}))
  }

  const closeModal = () => {

    if (isChanged.current) {
      if (window.confirm('You have unsaved data. Proceed?')) {
        setIsModal(prevState => ({...prevState, add: false, edit: false}))
        setIsTask(prevState => ({...prevState, second: false, third: false, fourth: false}))
        clearIsValidated()
        isChanged.current = false
      }
    } else {
      setIsModal(prevState => ({...prevState, add: false, edit: false}))
      setIsTask(prevState => ({...prevState, second: false, third: false, fourth: false}))
      clearIsValidated()
    }

  }

  const openJob = () => setIsModal(prevState => ({...prevState, job: true}))
  const closeJob = () => setIsModal(prevState => ({...prevState, job: false}))

  const selectJob = (e) => {

    let tr = e.target.parentNode
    let td = tr.getElementsByTagName('td')

    if (isValidated.jobNumber !== td[2].textContent) changedData()
    setIsValidated(prevState => ({...prevState, jobNumber: td[2].textContent}))
    closeJob()

  }

  const positionDescription = (e) => {
    descriptionPosition.current = e.target.selectionStart
    //console.log(`postion: ${descriptionPosition.current}`)
  }

  const positionEquipment = (e) => {
    equipmentPosition.current = e.target.selectionStart
    //console.log(`postion: ${equipmentPosition.current}`)
  }

  //========================================
  //==      creates PDFs for dailies      ==
  //========================================

  // function createPDF(data, object) {
  //
  //   if (data.signature === null || data.signature === '') {
  //
  //     alert('The owner of this daily has not provided a signature. Therefore a PDF cannot be created until a signature is provided.')
  //
  //   } else {
  //
  //     let techSignature = data.signature.replace(/ /g, "+") //global replace of ' '
  //
  //     let receivedBy = data.receivedBy
  //
  //     let dayName = getDayName(data.dailiesdate, true)
  //     let totalHours = String(Number(data.hours1) + Number(data.hours2) + Number(data.hours3) + Number(data.hours4)); //must be a string to print?
  //
  //     let doc = new jsPDF(); // declare now to use split text function below
  //
  //     //Create the PDF - Default export is a4 paper, portrait, using milimeters for units
  //     let xmin = 12; //17.5;
  //     let ymin = 32;
  //     let xmax = 196.5; //202;
  //     let ymax = 258 + 24; // extended 24 for testing final ymax
  //     let xtaskcode = xmin + 133.5; //151;
  //     let xcb = xmin + 178.5; //196;
  //     let spacing = 7.5;
  //     let spacingmemo = 10;
  //     let margin = 5;
  //     let xtaskcode2 = xtaskcode + ((xmax - xtaskcode)/2);
  //     let xtech = (xtaskcode/2 + xmin/2);
  //
  //     let xday;
  //     let xspacing;
  //     let imgData;
  //     let upperspacing;
  //
  //     let trimStr; // this is used to trim some str which are too long to fit in the space given
  //
  //     let blob;
  //
  //     // if (object === 'sign') {
  //     //
  //     //   receivedBy = data.receivedBy
  //     //   //receivedBySignature = signaturePad.current.toDataURL('image/jpeg')
  //     //
  //     //   // should signaturePad be cleared?
  //     //
  //     // } else {
  //     //
  //     //   receivedBy = data.receivedby === null ? '' : data.receivedby
  //     //
  //     // }
  //
  //     //console.log('start styling');
  //
  //     imgData = 'data:image/png;base64,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';
  //
  //     // determine how many pages and loop under each is created. will be merged after
  //
  //     //console.log(xmax-xmin);
  //     //description = doc.splitTextToSize(description, (xmax-xmin)); //wraps text within specified space, does not account for y axis
  //
  //     //start text
  //     doc.setFont('times', 'bold');
  //     //doc.setFontType('bold');
  //     doc.setFontSize(12);
  //
  //     let description = doc.splitTextToSize(data.description, (xmax - xmin - margin * 2)); // spacing creates a margin
  //
  //     let lineCount = description.length; // splitTextToSize actually turns description into an array!
  //
  //     let maxHeight = (ymax - spacing * 6) - (ymin + spacingmemo + spacing * 6 - 4.25);
  //     //console.log('maxHeight: ' + maxHeight);
  //     //var maxLines = Math.floor(maxHeight / 3.505729); // round down to nearest whole integer 12px = 3.175mm? 1.25px = 0.330729mm padding
  //     var maxLines = 30; // f it, i counted the max line that fits in the dialy
  //
  //     let pages = Math.ceil(lineCount / maxLines) || 1;
  //     let page = 1;
  //     let count = 1; // this is for merge. while finishes before php starts, thus page returns higher than pages
  //
  //     let files = []; // if multi-page, this is used in utl_pdf_merge.php
  //
  //     let address, city, state, zip // in case data. have null, check below
  //
  //     trimStr = doc.splitTextToSize(data.address + ', ' + data.city + ', ' + data.state + ' ' + data.zip, (xspacing*2 - 2));
  //
  //     while (page <= pages) {
  //
  //         files.push(`daily${data.id}_${page}.pdf`);
  //
  //         // start new doc for each page
  //
  //         doc = new jsPDF();
  //
  //         //description = doc.splitTextToSize(description, (xmax-xmin));
  //
  //         // add AKA logo
  //         //doc.addImage(imgData, 'JPEG', 50, 15, 120, 15);
  //         doc.addImage(imgData, 'JPEG', 46, 15, 116, 15);
  //
  //         //console.log('end aka logo');
  //         //console.log('start framework and general text');
  //
  //         //light gray
  //         doc.setFillColor(220, 220, 220);
  //         //doc.rect(xmin, ymin, xcb-xmin, ymin+spacingmemo-ymin, 'F');
  //         doc.rect(xtaskcode,ymax-spacing*6, xmax-xtaskcode, spacing, 'F');
  //         doc.rect(xtaskcode,ymax-spacing*4, xmax-xtaskcode, spacing, 'F');
  //         doc.rect(xtaskcode,ymax-spacing*2, xmax-xtaskcode, spacing, 'F');
  //
  //         //black
  //         doc.setDrawColor(0, 0, 0);
  //
  //         //outside frame
  //         doc.setLineWidth(1);
  //         doc.line(xmin, ymin, xmax, ymin); // horizontal top
  //         doc.line(xmin, ymin, xmin, ymax); // vertical left
  //         doc.line(xmin, ymax, xmax, ymax); // horizontal bottom
  //         doc.line(xmax, ymin, xmax, ymax); // vertical right
  //
  //         //upper horizontal
  //         doc.setLineWidth(0.5);
  //
  //         upperspacing = ymin+spacingmemo;
  //         doc.setLineWidth(1);
  //         doc.line(xmin, ymin+spacingmemo, xmax, ymin+spacingmemo);
  //         doc.setLineWidth(0.5);
  //         doc.line(xmin, upperspacing+spacing*3, xmax, upperspacing+spacing*3);
  //         doc.line(xmin, upperspacing+spacing*5, xmax, upperspacing+spacing*5);
  //         doc.setLineWidth(0.25);
  //         doc.line(xmin, upperspacing+spacing*1, xmax, upperspacing+spacing*1);
  //         doc.line(xmin, upperspacing+spacing*2, xmax, upperspacing+spacing*2);
  //         //doc.line(xmin, upperspacing+spacing*4, xmax, upperspacing+spacing*4); below equipment, text will wrap, so a line is not needed
  //         doc.setLineWidth(0.5);
  //         //doc.line(xcb, ymin+(spacingmemo/2), xmax, ymin+(spacingmemo/2)); //grading cb
  //
  //         //upper vertical
  //         xday = 145;
  //         xspacing = (xmax-xmin)/4;
  //
  //         //start text
  //         doc.setFont('times', 'bold');
  //         //doc.setFontType('bold');
  //         doc.setFontSize(14);
  //
  //         if (data.dailiestype === 'inspector') {
  //
  //           // gray header
  //
  //           doc.setFillColor(220, 220, 220);
  //           doc.rect(xmin, ymin, xmax-xmin, ymin+spacingmemo-ymin, 'F');
  //
  //           //black
  //           doc.setDrawColor(0, 0, 0);
  //
  //           doc.text((xmax-xmin)/2 + xmin-50, ymin+spacingmemo/2+1, 'SPECIAL INSPECTOR DAILY FIELD REPORT');
  //
  //           doc.setLineWidth(0.25);
  //
  //           doc.setFontSize(8);
  //
  //           doc.text(xmin+1, ymin+spacingmemo+spacing-4.25, 'JOB NO.');
  //
  //           doc.text(xmin + xspacing/2+1, ymin+spacingmemo+spacing-4.25, 'CLIENT/PROJECT');
  //
  //           doc.text(xday+1, ymin+spacingmemo+spacing-4.25, 'DAY');
  //
  //           doc.text((xmax-xday)/2+xday+1, ymin+spacingmemo+spacing-4.25, 'DATE');
  //
  //           doc.text(xmin+1, ymin+spacingmemo+spacing*2-4.25, 'LOCATION');
  //
  //           doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*2-4.25, 'PERMIT #');
  //
  //           doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*2-4.25, 'JURISDICTION');
  //
  //           doc.text(xmin+1, ymin+spacingmemo+spacing*3-4.25, 'SUB CONTRACTOR');
  //
  //           doc.text(xmin + xspacing*1+1, ymin+spacingmemo+spacing*3-4.25, 'FOREMAN');
  //
  //           doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*3-4.25, 'WEATHER');
  //
  //           //doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*3-4.25, 'YARDAGE TO DATE');
  //
  //           doc.text(xmin+1, ymin+spacingmemo+spacing*4-4.25, 'EQUIPMENT');
  //
  //           doc.line(xday, ymin+spacingmemo, xday, ymin+spacingmemo+spacing); //day
  //           doc.line((xmax-xday)/2+xday, ymin+spacingmemo, (xmax-xday)/2+xday, ymin+spacingmemo+spacing); //date
  //           doc.line(xmin + xspacing/2, ymin+spacingmemo, xmin + xspacing/2, ymin+spacingmemo+spacing); //client
  //           doc.line(xmin + xspacing*2, ymin+spacingmemo+spacing, xmin + xspacing*2, ymin+spacingmemo+spacing*2); //project
  //           doc.line(xmin + xspacing*3, ymin+spacingmemo+spacing, xmin + xspacing*3, ymin+spacingmemo+spacing*2); //yardage today
  //           doc.line(xmin + xspacing, ymin+spacingmemo+spacing*2, xmin + xspacing, ymin+spacingmemo+spacing*3); //foreman
  //           doc.line(xmin + xspacing*2, ymin+spacingmemo+spacing*2, xmin + xspacing*2, ymin+spacingmemo+spacing*3); //weather
  //           doc.line(xmin + xspacing*3, ymin+spacingmemo+spacing*2, xmin + xspacing*3, ymin+spacingmemo+spacing*3); //yardage to date
  //
  //           //console.log('start signature');
  //
  //           //Do signatures before rest, so that lines/text are not blocked by image box
  //           if (techSignature !== null && techSignature !== '') doc.addImage(techSignature, 'JPEG', xmin+1, ymax-spacing*3+6, 60, 15)
  //
  //           //console.log('start receivedby');
  //
  //           if (object === 'sign') doc.addImage(receivedBySignature.current, 'JPEG', xtech+1, ymax-spacing*3+6, 60, 15)
  //
  //           //console.log('end signatures');
  //
  //           //lower vertical
  //           doc.setLineWidth(0.5);
  //           doc.line(xtech,ymax-spacing*1,xtech,ymax-spacing*3); //between tech and recieved by
  //           doc.line(xtaskcode,ymax-spacing*6,xtaskcode,ymax); //task code and hours
  //           doc.line(xtaskcode2,ymax-spacing*6,xtaskcode2,ymax); //task code and hours
  //
  //           //lower horizontal - tech and recived by section
  //           doc.text(xmin+1, ymax-spacing*3+3, 'INSPECTOR (Print)');
  //
  //           doc.text(xmin+1, ymax-spacing*2+3, 'INSPECTOR (Signature)');
  //
  //           doc.text(xmin+1, ymax-spacing*1+3, 'INSPECTOR ID #');
  //           doc.text(xtech+1, ymax-spacing*3+3, 'RECEIVED BY (Print)');
  //
  //           doc.text(xtech+1, ymax-spacing*2+3, 'RECEIVED BY (Signature)');
  //
  //           doc.setLineWidth(0.5);
  //           doc.line(xmin, ymax-spacing*6, xtaskcode, ymax-spacing*6); // line for statement compliance
  //           doc.line(xmin, ymax-spacing*3, xtaskcode, ymax-spacing*3); // above received by print
  //           doc.line(xmin, ymax-spacing*2, xtaskcode, ymax-spacing*2); // above received by sig
  //           doc.line(xmin, ymax-spacing*1, xtaskcode, ymax-spacing*1); // above inspec id #
  //
  //           //lower horizontal - task code and hours
  //           doc.text(xtaskcode+5, ymax-spacing*6+3, 'ACTIVITY');
  //           doc.text(xtaskcode+8, ymax-spacing*6+6, 'CODE');
  //
  //           doc.text(xtaskcode2+7, ymax-spacing*6+4.5, 'HOURS');
  //
  //           doc.text(xtaskcode+7, ymax-spacing*1+4.5, 'TOTAL');
  //
  //           //Statement of compliance header
  //           doc.text(xmin + 1, ymax-spacing*6+3, 'STATEMENT OF COMPLIANCE');
  //
  //           //Statement of compliance body
  //           let statement = 'I declare under penalty of perjury that the above statements are true, and that, to the best of my knowledge, the work described in this report has been performed / installed in compliance with the approved plans, project specifications, and all applicable codes.'
  //           statement = doc.splitTextToSize(statement, (xtaskcode - xmin - 2))
  //           doc.text(xmin + 1, ymax-spacing*5+3, statement)
  //
  //           // add the text here
  //
  //           doc.setFontSize(12);
  //
  //           doc.text(xmin+1, ymax-spacing*1+6, data.inspectorId);
  //
  //           doc.text(xmin+1, ymin+spacingmemo+spacing-1.25, props.filter.jobNumber); //job number text
  //
  //           trimStr = doc.splitTextToSize(data.client + ' / ' + data.project, (xday - xmin + xspacing - 2));
  //
  //             doc.text(xmin + xspacing / 2 + 1, ymin+spacingmemo+spacing - 1.25, trimStr[0]); //client text
  //
  //           doc.text(xday + 1, ymin+spacingmemo + spacing - 1.25, dayName); //day text
  //           doc.text((xmax - xday)/2 + xday + 1, ymin + spacingmemo + spacing - 1.25, formatDateYMD(data.dailiesdate)); //date text
  //
  //           address = data.address === null ? '' : data.address
  //           city = data.city === null ? '' : data.city
  //           state = data.state === null ? '' : data.state
  //           zip = data.zip === null ? '' : data.zip
  //
  //           trimStr = doc.splitTextToSize(`${address}, ${city}, ${state} ${zip}`, (xspacing*2 - 2));
  //
  //             doc.text(xmin+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //location text
  //
  //           trimStr = doc.splitTextToSize(data.permitNo, (xspacing - 2));
  //
  //             doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //project eng text
  //
  //           trimStr = doc.splitTextToSize(data.jurisdiction, (xspacing - 2));
  //
  //             doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //jurisdiction
  //
  //           trimStr = doc.splitTextToSize(data.contractor, (xspacing - 2));
  //
  //             doc.text(xmin+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //contractor
  //
  //           trimStr = doc.splitTextToSize(data.foreman, (xspacing - 2));
  //
  //             doc.text(xmin + xspacing*1+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //foreman text
  //
  //           trimStr = doc.splitTextToSize(data.weather, (xspacing - 2))
  //
  //             doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //weather text
  //
  //           //doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*3-1.25, data.yardagetodate); //yardage text
  //
  //           trimStr = doc.splitTextToSize(data.equipment, (xmax-xmin)); //wraps text within specified space, does not account for y axis
  //
  //             doc.text(xmin+1, ymin+spacingmemo+spacing*4-1.25, trimStr); //equipment text
  //
  //           //see above before while startX
  //           //description = doc.splitTextToSize(description, (xmax-xmin)); //wraps text within specified space, does not account for y axis
  //           //doc.text(xmin+1, ymin+spacingmemo+spacing*6-4.25, description); //description text
  //
  //           doc.text( xmin + margin, ymin + margin + spacingmemo + spacing * 6 - 4.25, description.slice( 0, maxLines )); //print each page's content
  //           description.splice(0, maxLines); // now remove printed lines --> notice its s'P'lice and not slice. no need for description = des..etc
  //
  //         } else {
  //
  //           // gray header
  //
  //           doc.setFillColor(220, 220, 220);
  //           doc.rect(xmin, ymin, xcb-xmin, ymin+spacingmemo-ymin, 'F');
  //           doc.line(xcb, ymin+(spacingmemo/2), xmax, ymin+(spacingmemo/2)); //grading cb
  //
  //           //black
  //           doc.setDrawColor(0, 0, 0);
  //
  //           doc.text((xmax-xmin)/2 + xmin-30, ymin+spacingmemo/2+1, 'DAILY FIELD REPORT');
  //           doc.text((48+xmin)/2+5, ymin+spacingmemo*0.75-1, String(isValidated.memoNo === null ? '' : isValidated.memoNo)); //memno text
  //
  //           doc.setLineWidth(0.5);
  //           //doc.line(48, ymin, 48, ymin+spacingmemo); //memo
  //           doc.setFontSize(10);
  //           //doc.text(xmin+1, ymin+spacingmemo/2-1, 'MEMO');
  //           //doc.text(xmin+1, ymin+spacingmemo-1, 'NO.');
  //
  //           doc.line(xcb, ymin, xcb, ymin+spacingmemo); //grading cb
  //           doc.text(xmax-25.5, ymin+spacingmemo/2-1, 'GRADING');
  //           doc.text(xmax-36, ymin+spacingmemo-1, 'POST-GRADING');
  //
  //           //mark the grading phase with an X
  //           if (props.filter.gradeId === 'RG') {
  //               doc.text(xcb+1.5, ymin+spacingmemo/2-1, 'X');
  //           }
  //
  //           else if (props.filter.gradeId === 'PG') {
  //               doc.text(xcb+1.5, ymin+spacingmemo-1, 'X');
  //           }
  //
  //           doc.setLineWidth(0.25);
  //
  //           doc.setFontSize(8);
  //
  //           doc.text(xmin+1, ymin+spacingmemo+spacing-4.25, 'JOB NO.');
  //
  //           doc.text(xmin + xspacing/2+1, ymin+spacingmemo+spacing-4.25, 'CLIENT/PROJECT');
  //
  //           doc.text(xday+1, ymin+spacingmemo+spacing-4.25, 'DAY');
  //
  //           doc.text((xmax-xday)/2+xday+1, ymin+spacingmemo+spacing-4.25, 'DATE');
  //
  //           doc.text(xmin+1, ymin+spacingmemo+spacing*2-4.25, 'LOCATION/TRACT');
  //
  //           doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*2-4.25, 'PROJECT ENG/GEO');
  //
  //           doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*2-4.25, 'YARDAGE TODAY');
  //
  //           doc.text(xmin+1, ymin+spacingmemo+spacing*3-4.25, 'CONTRACTOR');
  //
  //           doc.text(xmin + xspacing*1+1, ymin+spacingmemo+spacing*3-4.25, 'FOREMAN');
  //
  //           doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*3-4.25, 'WEATHER');
  //
  //           doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*3-4.25, 'YARDAGE TO DATE');
  //
  //           doc.text(xmin+1, ymin+spacingmemo+spacing*4-4.25, 'EQUIPMENT');
  //
  //           doc.line(xday, ymin+spacingmemo, xday, ymin+spacingmemo+spacing); //day
  //           doc.line((xmax-xday)/2+xday, ymin+spacingmemo, (xmax-xday)/2+xday, ymin+spacingmemo+spacing); //date
  //           doc.line(xmin + xspacing/2, ymin+spacingmemo, xmin + xspacing/2, ymin+spacingmemo+spacing); //client
  //           doc.line(xmin + xspacing*2, ymin+spacingmemo+spacing, xmin + xspacing*2, ymin+spacingmemo+spacing*2); //project
  //           doc.line(xmin + xspacing*3, ymin+spacingmemo+spacing, xmin + xspacing*3, ymin+spacingmemo+spacing*2); //yardage today
  //           doc.line(xmin + xspacing, ymin+spacingmemo+spacing*2, xmin + xspacing, ymin+spacingmemo+spacing*3); //foreman
  //           doc.line(xmin + xspacing*2, ymin+spacingmemo+spacing*2, xmin + xspacing*2, ymin+spacingmemo+spacing*3); //weather
  //           doc.line(xmin + xspacing*3, ymin+spacingmemo+spacing*2, xmin + xspacing*3, ymin+spacingmemo+spacing*3); //yardage to date
  //
  //           //console.log('start signature');
  //
  //           //Do signatures before rest, so that lines/text are not blocked by image box
  //           if (techSignature !== null && techSignature !== '') doc.addImage(techSignature, 'JPEG', xmin+1, ymax-spacing*3+6, 60, 15)
  //
  //           //console.log('start receivedby');
  //
  //           if (object === 'sign') doc.addImage(receivedBySignature.current, 'JPEG', xtech+1, ymax-spacing*3+6, 60, 15)
  //
  //           //console.log('end signatures');
  //
  //           //lower vertical
  //           doc.setLineWidth(0.5);
  //           doc.line(xtech,ymax-spacing*1,xtech,ymax-spacing*3); //vertical between tech and received by
  //           doc.line(xtaskcode,ymax-spacing*6,xtaskcode,ymax); // vertical left of task code
  //           doc.line(xtaskcode2,ymax-spacing*6,xtaskcode2,ymax); // vertical left of hours
  //
  //           //lower horizontal - tech and recived by section
  //
  //           let jobTitle = data.dailiestype === 'engineer' ? 'ENGINEER' : data.dailiestype === 'geologist' ? 'GEOLOGIST' : 'TECHNICIAN'
  //
  //           doc.text(xmin+1, ymax-spacing*3+3, `${jobTitle} (Print)`);
  //
  //           doc.text(xmin+1, ymax-spacing*2+3, `${jobTitle} (Signature)`);
  //
  //           doc.text(xmin+1, ymax-spacing*1+3, 'DISTRIBUTION');
  //           doc.text(xtech+1, ymax-spacing*3+3, 'RECEIVED BY (Print)');
  //
  //           doc.text(xtech+1, ymax-spacing*2+3, 'RECEIVED BY (Signature)');
  //
  //           doc.setLineWidth(0.5);
  //           doc.line(xmin, ymax-spacing*3, xtaskcode, ymax-spacing*3); // above received by print
  //           doc.line(xmin, ymax-spacing*2, xtaskcode, ymax-spacing*2); // above received by sig
  //           doc.line(xmin, ymax-spacing*1, xtaskcode, ymax-spacing*1); // above distribution
  //
  //           //lower horizontal - task code and hours
  //           doc.text(xtaskcode+5, ymax-spacing*6+3, 'ACTIVITY');
  //           doc.text(xtaskcode+8, ymax-spacing*6+6, 'CODE');
  //
  //           doc.text(xtaskcode2+7, ymax-spacing*6+4.5, 'HOURS');
  //
  //           doc.text(xtaskcode+7, ymax-spacing*1+4.5, 'TOTAL');
  //
  //           //console.log('start adding database text');
  //
  //           // add the text here
  //
  //           doc.setFontSize(12);
  //
  //           doc.text(xmin+1, ymin+spacingmemo+spacing-1.25, props.filter.jobNumber); //job number text
  //
  //           //console.log(`client: ${data.client}`)
  //
  //           trimStr = doc.splitTextToSize(data.client + ' / ' + data.project, (xday - xmin + xspacing - 2));
  //
  //           //console.log(`trimStr: ${trimStr}`)
  //
  //           //doc.text(xmin + xspacing / 2 + 1, ymin+spacingmemo+spacing - 1.25, client + ' / ' + project); //client text
  //           doc.text(xmin + xspacing / 2 + 1, ymin+spacingmemo+spacing - 1.25, trimStr[0]); //client text
  //
  //           //console.log(`trimStr: ${trimStr}`)
  //
  //           doc.text(xday + 1, ymin+spacingmemo + spacing - 1.25, dayName); //day text
  //           doc.text((xmax - xday)/2 + xday + 1, ymin + spacingmemo + spacing - 1.25, formatDateYMD(data.dailiesdate, true)); //date text
  //           //doc.text(xmin+1, ymin+spacingmemo+spacing*2-1.25, address + ', ' + city + ', ' + county + ' ' + state + ' ' + zip); //location text
  //
  //           address = data.address === null ? '' : data.address
  //           city = data.city === null ? '' : data.city
  //           state = data.state === null ? '' : data.state
  //           zip = data.zip === null ? '' : data.zip
  //
  //           trimStr = doc.splitTextToSize(`${address}, ${city}, ${state} ${zip}`, (xspacing*2 - 2));
  //
  //             doc.text(xmin+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //location text
  //
  //           trimStr = doc.splitTextToSize(data.pe + ' / ' + data.pg, (xspacing - 2));
  //
  //             doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //project eng text
  //
  //           trimStr = doc.splitTextToSize(data.yardagetoday, (xspacing - 2));
  //
  //             doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //jurisdiction
  //
  //           trimStr = doc.splitTextToSize(data.contractor, (xspacing - 2));
  //
  //             doc.text(xmin+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //contractor
  //
  //           trimStr = doc.splitTextToSize(data.foreman, (xspacing - 2));
  //
  //             doc.text(xmin + xspacing*1+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //foreman text
  //
  //           trimStr = doc.splitTextToSize(data.weather, (xspacing - 2))
  //
  //             doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //weather text
  //
  //           trimStr = doc.splitTextToSize(data.yardagetodate, (xspacing - 2))
  //
  //             doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //yardage text
  //
  //           trimStr = doc.splitTextToSize(data.equipment, (xmax-xmin)); //wraps text within specified space, does not account for y axis
  //
  //             doc.text(xmin+1, ymin+spacingmemo+spacing*4-1.25, trimStr); //equipment text
  //
  //           //see above before while startX
  //           //description = doc.splitTextToSize(description, (xmax-xmin)); //wraps text within specified space, does not account for y axis
  //           //doc.text(xmin+1, ymin+spacingmemo+spacing*6-4.25, description); //description text
  //
  //           doc.text( xmin + margin, ymin + margin + spacingmemo + spacing * 6 - 4.25, description.slice( 0, maxLines )); //print each page's content
  //           description.splice(0, maxLines); // now remove printed lines --> notice its s'P'lice and not slice. no need for description = des..etc
  //
  //         }
  //
  //         doc.text(xmin+1, ymax-spacing*3+6, data.fullname);
  //         doc.text(xtech+1, ymax-spacing*3+6, String(receivedBy));
  //
  //         doc.text(xtaskcode+10, ymax-spacing*5+4.5, data.taskcode1);
  //         doc.text(xtaskcode+10, ymax-spacing*4+4.5, data.taskcode2);
  //         doc.text(xtaskcode+10, ymax-spacing*3+4.5, data.taskcode3);
  //         doc.text(xtaskcode+10, ymax-spacing*2+4.5, data.taskcode4);
  //
  //         doc.text(xtaskcode2+11, ymax-spacing*5+4.5, data.hours1);
  //         doc.text(xtaskcode2+11, ymax-spacing*4+4.5, data.hours2);
  //         doc.text(xtaskcode2+11, ymax-spacing*3+4.5, data.hours3);
  //         doc.text(xtaskcode2+11, ymax-spacing*2+4.5, data.hours4);
  //
  //         doc.text(xtaskcode2+11, ymax-spacing*1+4.5, totalHours);
  //
  //         // text finished, wrap up footer
  //
  //         doc.setFontSize(11);
  //         doc.text(xtaskcode+7, ymax+4.5, 'PAGE');
  //         doc.text(xtaskcode2-2, ymax+4.5, String(page));
  //         doc.text(xtaskcode2+5, ymax+4.5, 'OF');
  //         doc.text(xtaskcode2+15, ymax+4.5, String(pages));
  //         doc.setFontSize(9);
  //         doc.setFont('times', 'bolditalic');
  //         //doc.setFontType('bolditalic');
  //         doc.text(xmin, ymax+4.5, '1011 North Armando Street, Anaheim CA 92806 (714) 630-1626 FAX (714) 630-1916');
  //
  //         doc.setLineWidth(0.5);
  //         doc.line(xtaskcode, ymax-spacing*6, xmax, ymax-spacing*6); // above activity code
  //         doc.line(xtaskcode, ymax-spacing*5, xmax, ymax-spacing*5); // below activity code
  //         doc.setLineWidth(0.25);
  //         doc.line(xtaskcode, ymax-spacing*4, xmax, ymax-spacing*4); // horiz lines for activity codes and hours
  //         doc.line(xtaskcode, ymax-spacing*3, xmax, ymax-spacing*3);
  //         doc.line(xtaskcode, ymax-spacing*2, xmax, ymax-spacing*2);
  //         doc.line(xtaskcode,ymax-spacing*1, xmax, ymax-spacing*1);
  //
  //         blob = doc.output('blob');
  //
  //         let fileData = new FormData();
  //         fileData.append('page', page);
  //         fileData.append('pages', pages);
  //         fileData.append('filePath', 'dailies')
  //         fileData.append('fileName', pages > 1 ? `daily${data.id}_${page}.pdf` : `daily${data.id}.pdf`);
  //         fileData.append('filePDF', blob);
  //
  //         //console.log('upload it');
  //
  //         fetch('/api/uploadDaily', {
  //           method: 'post',
  //           body: fileData
  //         })
  //         .then(res=>res.json())
  //         .then(
  //           (result) => {
  //             //console.log('result: ' + JSON.stringify(result))
  //
  //             //now merge the PDFs if necessary
  //
  //             if (count === pages && count > 1) {
  //
  //             // let derp = true
  //             //
  //             // if (derp) {
  //
  //               fetch('/api/mergePDFs', {
  //                 method: 'post',
  //                 headers: {
  //                   'Accept': 'application/json, text/plain, */*',
  //                   'Content-Type': 'application/json'
  //                 },
  //                 body: JSON.stringify({
  //                   fileName: `daily${data.id}.pdf`,
  //                   fileArray: files
  //                 })
  //               })
  //               .then(res=>res.json())
  //               .then(
  //                 (result) => {
  //                   //console.log('result: ' + result)
  //
  //                   setIsModal(prevState => ({...prevState, sign: false}))
  //
  //                   window.open(`${path}${data.id}.pdf`)
  //
  //                 },
  //                 (error) => {
  //                   catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'mergePDFs', JSON.stringify(error), props.user.username, props.user.device)
  //                 }
  //               )
  //
  //             }
  //
  //             else if (count === pages) {
  //
  //               setIsModal(prevState => ({...prevState, sign: false}))
  //
  //               window.open(`${path}${data.id}.pdf`)
  //
  //             }
  //
  //             else if (count < pages) {
  //
  //                 // merging
  //                 //console.log('page: ' + count + ' pages: ' + pages);
  //
  //             }
  //
  //             else {
  //
  //                 alert('Error: the number of pages could not be determined. Contact and admin.');
  //                 console.log('count: ' + count + ' pages: ' + pages);
  //
  //             }
  //
  //             count++ // increments for merge. while finished before php starts, so page is always pages + 1
  //
  //           },
  //           (error) => {
  //
  //             alert('Error: could not upload Daily. Contact and admin.')
  //             catchError(props.filter.jobNumber, props.filter.gradeId, props.component, 'uploadDaily', JSON.stringify(error), props.user.username, props.user.device)
  //           }
  //         )
  //
  //         page++; // increments the page count
  //
  //     } // end while
  //
  //   }
  //
  // }

  fileArray.current = [] // clear before pushing

  let listOfData = fetchedData.map((data, i) => {

    let jn = data.jobnumber === null ? '' : data.jobnumber
    let gd = data.gradeid === null ? '' : data.gradeid === 'RG' ? 'Grading' : data.gradeid === 'PG' ? 'Post' : ''
    let type = data.dailiestype === null ? '' : data.dailiestype
    let description = data.description === null ? '' : data.description
    let status = data.dailiesstatus === null ? '' : data.dailiesstatus
    let dailiesDate = data.dailiesdate === null ? '' : data.dailiesdate
    let entryBy = data.entryby !== null && data.entryby !== '' ? data.entryby : ''
    let entryTime = data.entrytime === null ? '' : formatDateTime(data.entrytime)
    let completeBy = data.completeby !== null && data.completeby !== '' ? data.completeby : ''
    let completeTime = data.completetime === null ? '' : formatDateTime(data.completetime)
    let modBy = data.modby !== null && data.modby !== '' ? data.modby : ''
    let modTime = data.modtime === null ? '' : formatDateTime(data.modtime)

    let filter = filterData(data, searchValue)

    if (
      ((isUnsignedDailies && status === 'Incomplete') || !isUnsignedDailies) &&
      filter
    ) {

      fileArray.current.push(`daily${data.id}.pdf`)

      return (
        <tr key={data.id.toString()} data-i={i} data-id={data.id} onClick={selectRow} onMouseOver={hightlightMarker}>          
          {isModal.google ?
            <td>
              {data.entrylat === '' || data.entrylat === null || data.entrylng === '' || data.entrylng === null ?
              <Icon name='wrong_location' color='tomato' /> :
              <Icon name='where_to_vote' color='dodgerblue' />}
            </td> : null
          }
          {props.filter.jobNumber === null || props.filter.jobNumber === '' ?
            <>
              <td>{jn}</td>
              <td>{gd}</td>
            </> : null
          }
          <td>{dailiesDate}</td>
          <td>{type}</td>
          {!isModal.preview ? <td className='clipText'>{description}</td> : null}
          <td style={{background: status === 'Incomplete' ? 'orange' : 'dodgerblue', color: 'white'}}>{status}</td>
          {!isModal.preview ?
            <>
              <td><span style={{color: 'dodgerblue'}}>{entryBy}</span> <span style={{color: 'gray'}}>{entryTime}</span></td>              
              <td><span style={{color: 'dodgerblue'}}>{completeBy}</span> <span style={{color: 'black'}}><b>{completeTime}</b></span></td>              
              <td><span style={{color: 'dodgerblue'}}>{modBy}</span> <span style={{color: 'gray'}}>{modTime}</span></td>              
            </> : null
          }
        </tr>
      )
    }

  })

  let listOfTasks = fetchedTasks.map(task => <option value={task.task}>{task.task} - {task.description}</option>)  

  // let menuContent = (
  //   <div style={{display: 'inline-block', textAlign: 'left'}}>
  //     <div><SquareButton iconName='picture_as_pdf' onClick={viewDaily} /><span>View PDF</span></div>
  //     <div><SquareButton iconName='edit' onClick={openEdit} /><span>Edit</span></div>
  //     <div><SquareButton iconName='assignment' onClick={openSign} /><span>Sign</span></div>

  //   </div>
  // )

  // <div><SquareButton iconName='delete' onClick={deleteDaily} color='tomato' /><span>Delete</span></div>

  // let signContent = (
  //   <div>
  //     <input type="text" className="signature-pad--full-name" placeholder="Please provide full name here" pattern=".{1,}" name='receivedBy' onInput={validate} onChange={changedData} required />

  //     <div className="signature-pad">

  //       <div className="signature-pad--body">
  //         <div className="signature-pad--body-x">X</div>
  //         <div className="signature-pad--body-note">Sign above</div>
  //         <canvas ref={canvasSign}></canvas>
  //       </div>

  //     </div>
  //   </div>
  // )

  let modalContent = (
    <div>

      <div style={{textAlign: 'center'}}>

        <div>
          <label className='label'>JN</label>
          <input style={{width: 75}} className='input' type="text" value={isValidated.jobNumber} onClick={openJob} />
        </div>

        <div>
          <label className='label'>Grading</label>
          <select style={{width: 75}} className='select' pattern=".{1,}" name='gradeId' onInput={validate} onChange={changedData} defaultValue={isValidated.gradeId} required>
            <option value=''></option>
            <option value='RG'>Grading</option>
            <option value='PG'>Post</option>
          </select>
        </div>

        <div>
          <label className='label'>Date</label>
          <input className='input' type="date" pattern=".{1,}" name='dailiesDate' onInput={validate} onChange={changedData} defaultValue={isValidated.dailiesDate === '' || isValidated.dailiesDate === null ? null : isValidated.dailiesDate} required />
        </div>

        <div>
          <label className='label'>Daily Type</label>
          <select className='select' pattern=".{1,}" name='dailiesType' onInput={validate} onChange={changedData} defaultValue={isValidated.dailiesType} required>
            <option value=""></option>
            <option value="technician">Technician</option>
            <option value="inspector">Inspector</option>
            <option value="engineer">Engineer</option>
            <option value="geologist">Geologist</option>
          </select>
        </div>

        {isValidated.dailiesType === 'inspector' ?

          <>

            <div>
              <div><label className='label'>Permit No.</label></div>
              <textarea
                style={{height: 50}}
                className='textArea'
                pattern=".{1,}"
                name='permitNo'
                onInput={validate}
                onChange={changedData}
                defaultValue={isModal.add && fetchedData.length > 0 ? fetchedData[fetchedData.length-1].permitNo : isValidated.permitNo}
                required
              />
            </div>

            <div>
              <div><label className='label'>Jurisdiction</label></div>
              <textarea
                style={{height: 50}}
                className='textArea'
                pattern=".{1,}"
                name='jurisdiction'
                onInput={validate}
                onChange={changedData}
                defaultValue={isModal.add && fetchedData.length > 0 ? fetchedData[fetchedData.length-1].jurisdiction : isValidated.jurisdiction}
                required
              />
            </div>

            <div>
              <div><label className='label'>Inspector ID</label></div>
              <textarea
                style={{height: 50}}
                className='textArea'
                pattern=".{1,}"
                name='inspectorId'
                onInput={validate}
                onChange={changedData}
                defaultValue={isModal.add && fetchedData.length > 0 ? fetchedData[fetchedData.length-1].inspectorId : isValidated.inspectorId}
                required
              />
            </div>

          </> : null

        }

      </div>

      <div style={{textAlign: 'center'}}>

        <div>
          <div><label className='label'>Contractor</label></div>
          <textarea
            style={{height: 50}}
            className='textArea'
            pattern="[a-zA-Z0-9]{1,}"
            name='contractor'
            onInput={validate}
            onChange={changedData}
            defaultValue={isModal.add && fetchedData.length > 0 ? fetchedData[fetchedData.length-1].contractor : isValidated.contractor}
            required
          />
        </div>

        <div>
          <div><label className='label'>Foreman</label></div>
          <textarea
            style={{height: 50}}
            className='textArea'
            pattern="[a-zA-Z0-9]{1,}"
            name='foreman'
            onInput={validate}
            onChange={changedData}
            defaultValue={isModal.add && fetchedData.length > 0 ? fetchedData[fetchedData.length-1].foreman : isValidated.foreman}
            required
          />
        </div>

        <div>
          <label className='label'>Weather</label>
          <select className='select' pattern=".{1,}" name='weather' onInput={validate} onChange={changedData} defaultValue={isValidated.weather} required>
            <option value=""></option>
            <option value="Sunny and Warm">Sunny and Warm</option>
            <option value="Sunny and Cool">Sunny and Cool</option>
            <option value="Sunny and Windy">Sunny and Windy</option>
            <option value="Cloudy and Warm">Cloudy and Warm</option>
            <option value="Cloudy and Cool">Cloudy and Cool</option>
            <option value="Cloudy and Windy">Cloudy and Windy</option>
          <option value="Rainy">Rainy</option>
          </select>
        </div>

        <div>
          <label className='label'>Yardage Today</label>
          <input style={{width: 75}} className='input' type="text" pattern="\d{1,}(\.\d{1})?" name='yardageToday' onInput={validate} onChange={changedData} defaultValue={isValidated.yardageToday} required />
        </div>

        <div>
          <label className='label'>Yardage To Date</label>
          <input style={{width: 75}} className='input' type="text" pattern="\d{1,}(\.\d{1})?" name='yardageToDate' onInput={validate} onChange={changedData} defaultValue={isValidated.yardageToDate} required />
        </div>

        <div>
          <div><label className='label'>Equipment</label><Icon name='add_circle' onClick={openEquipment}/></div>
          <textarea
            style={{height: 50}}
            className='textArea'
            pattern="[a-zA-Z0-9]{1,}"
            name='equipment'
            onInput={validate}
            onChange={changedData}
            onClick={positionEquipment}
            onKeyUp={positionEquipment}
            defaultValue={isModal.add && fetchedData.length > 0 ? fetchedData[fetchedData.length-1].equipment : isValidated.equipment}
            required
          />
        </div>

        <div>
          <div><label className='label'>Description</label><Icon name='add_circle' onClick={openDescription}/></div>
          <textarea style={{height: 400}} className='textArea' pattern="[a-zA-Z0-9]{1,}" name='description' onInput={validate} onChange={changedData} onClick={positionDescription} onKeyUp={positionDescription} value={isValidated.description} required></textarea>
        </div>

        <div>
          <div style={{display: 'inline-block'}}>

            <div style={{
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center'
            }}>

              <div>
                <label className='label'>Task</label>
              </div>

              <div style={{marginLeft: 30}}>
                <label className='label'>Hours</label>
              </div>

            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center'
            }}>

              <div>
                <select style={{width: 75}} className='select' pattern=".{1,}" name='taskCode1' onInput={validate} onChange={changedData} value={isValidated.taskCode1} required>
                  <option value=""></option>
                  {listOfTasks}
                </select>
              </div>

              <div>
                <input style={{width: 75}} className='input' type="text" pattern="\d{1,2}(\.\d{1,2})?" name='hours1' onInput={validate} onChange={changedData} value={isValidated.hours1} required />
              </div>

              <Icon name='cancel' color='tomato' outline={true} onClick={removeTask1} />

            </div>
          </div>
        </div>

        {isTask.second || isValidated.taskCode2 !== '' ?

          <div>
            <div style={{display: 'inline-block'}}>

              <div style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center'
              }}>

                <div>
                  <label className='label'>Task</label>
                </div>

                <div style={{marginLeft: 30}}>
                  <label className='label'>Hours</label>
                </div>

              </div>

              <div style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center'
              }}>

                <div>
                  <select style={{width: 75}} className='select' pattern=".{1,}" name='taskCode2' onInput={validate} onChange={changedData} defaultValue={isValidated.taskCode2} required>
                    <option value=""></option>
                    {listOfTasks}
                  </select>
                </div>

                <div>
                  <input style={{width: 75}} className='input' type="text" pattern="\d{1,2}(\.\d{1,2})?" name='hours2' onInput={validate} onChange={changedData} defaultValue={isValidated.hours2} required />
                </div>

                <Icon name='cancel' color='tomato' outline={true} onClick={removeTask2} />

              </div>
            </div>
          </div> : null

        }

        {isTask.third || isValidated.taskCode3 !== '' ?

          <div>
            <div style={{display: 'inline-block'}}>

              <div style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center'
              }}>

                <div>
                  <label className='label'>Task</label>
                </div>

                <div style={{marginLeft: 30}}>
                  <label className='label'>Hours</label>
                </div>

              </div>

              <div style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center'
              }}>

                <div>
                  <select style={{width: 75}} className='select' pattern=".{1,}" name='taskCode3' onInput={validate} onChange={changedData} defaultValue={isValidated.taskCode3} required>
                    <option value=""></option>
                    {listOfTasks}
                  </select>
                </div>

                <div>
                  <input style={{width: 75}} className='input' type="text" pattern="\d{1,2}(\.\d{1,2})?" name='hours3' onInput={validate} onChange={changedData} defaultValue={isValidated.hours3} required />
                </div>

                <Icon name='cancel' color='tomato' outline={true} onClick={removeTask3} />

              </div>
            </div>
          </div> : null

        }

        {isTask.fourth || isValidated.taskCode4 !== '' ?

          <div>

            <div style={{display: 'inline-block'}}>

              <div style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center'
              }}>

                <div>
                  <label className='label'>Task</label>
                </div>

                <div style={{marginLeft: 30}}>
                  <label className='label'>Hours</label>
                </div>

              </div>

              <div style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center'
              }}>

                <div>
                  <select style={{width: 75}} className='select' pattern=".{1,}" name='taskCode4' onInput={validate} onChange={changedData} defaultValue={isValidated.taskCode4} required>
                    <option value=""></option>
                    {listOfTasks}
                  </select>
                </div>

                <div>
                  <input style={{width: 75}} className='input' type="text" pattern="\d{1,2}(\.\d{1,2})?" name='hours4' onInput={validate} onChange={changedData} defaultValue={isValidated.hours4} required />
                </div>

                <Icon name='cancel' color='tomato' outline={true} onClick={removeTask4} />

              </div>
            </div>
          </div> : null

        }

        {!isTask.fourth ? <IconAndText text='Add Task?' name='add_circle' onClick={addTask} /> : null}

        <div>
          <label style={{fontSize: 20}} className='label'>Status</label>
          <select style={{fontSize: 20}} className='select' pattern=".{1,}" name='dailiesStatus' onInput={validate} onChange={changedData} defaultValue={isValidated.dailiesStatus} required>
            <option value="Incomplete">Incomplete</option>
            <option value="Complete">Complete</option>
            {isValidated.dailiesStatus === 'Signed' ? <option value="Signed">Signed</option> : null}
          </select>
        </div>

      </div>

    </div>
  )

  // <IconAndText text='Add photo?' name='add_a_photo' onClick={null} />
  //
  // <IconAndText text='Add Video?' name='video_call' onClick={null} />

  // {isModal.menu ? <Modal content={menuContent} closeModal={closeMenu} width='none' height='none' /> : null}

  //{isModal.sign ? <Modal add={signDaily} undo={undoSignature} content={signContent} closeModal={closeSign} height='none' /> : null}

  return (
    <>
      {isModal.add || isModal.edit ? <Modal add={isModal.add ? addDaily : isModal.edit ? editDaily : null} delete={isModal.edit ? deleteDaily : null} view={isModal.edit ? viewDaily : null} content={modalContent} closeModal={closeModal} isValidated={isValidated} isModal={isModal} /> : null}
      {isModal.sign ? <Sign parent='daily' signDaily={signDaily} close={closeSign} /> : null}
      {isModal.description ? <DailyDescription select={selectDailyDescription} close={closeDescription} /> : null}
      {isModal.equipment ? <EquipDescription select={selectEquipDescription} close={closeEquipment} /> : null}
      {isModal.job ? <Job selectJob={selectJob} closeModal={closeJob} /> : null}
      {!isModal.loading ?
        <div style={{display: 'flex', width: '100%', height: '100%', overflow: 'auto'}}>

          <div style={{margin: 10, flex: isModal.google || isModal.plan || isModal.preview ? '0 1 auto' : '1 0 auto', maxWidth: '100%'}}>

            <div style={{display: 'flex', flexFlow: 'column', width: '100%', height: '100%'}}>

              <div style={{width: '100%'}}>

                {props.user.device === 'desktop' ? <Icon name='add_circle' title='Add' onClick={openAdd} /> : <AddButton onClick={openAdd} />}
                <Icon name='file_download' title='Download Dailies' onClick={downloadDailies} />
                <Icon name='assignment_late' title='View Incomplete Dailies' color={isUnsignedDailies ? 'tomato' : 'gray'} onClick={viewUnsignedDailies} />
                <Icon name='preview' title='Split Screen' color={isModal.preview ? 'dodgerblue' : 'gray'} onClick={togglePreview} />
                <Icon name='refresh' title='Refresh' onClick={fetchData} />

                {props.component === 'Manage' ?
                  <>
                    <Icon name='location_on' title='View map' color={isModal.google ? 'dodgerblue' : 'gray'} onClick={toggleGoogle} />
                  </> : null
                }
              </div>

              <SearchBar search={search} clearSearch={clearSearch} />

              {fetchedData.length > 0 ?

                <>

                  <small style={{margin: 10}}>{fetchedData.length} Total Records. (If no filters, limit 100)</small>

                  <div style={{margin: 10, flex: '1', overflow: 'auto'}}>

                    <table>

                      <thead>
                        <tr>
                          {isModal.google ? <th></th> : null}
                          {props.filter.jobNumber === null || props.filter.jobNumber === '' ? <><th>JN</th><th></th></> : null}
                          <th>Date</th>
                          <th>Type</th>
                          {!isModal.preview ? <th>Descrip.</th> : null }
                          <th>Status</th>
                          {!isModal.preview ?
                            <>
                              <th>Start</th>                              
                              <th>Complete</th>
                              <th>Modified</th>
                            </> : null
                          }
                        </tr>
                      </thead>

                      <tbody>
                        {listOfData}
                      </tbody>

                    </table>

                  </div>

                </> :
                <p style={{margin: 10}}>No dailies found.</p>

              }

            </div>

          </div>

          {isModal.google ?

            <div style={{margin: 10, flex: '1 0 auto', overflow: 'auto'}}>
              <div style={{height: '100%', width: '100%'}} ref={googleRef}></div>
            </div> : null

          }

          {isModal.preview ?

            <div style={{margin: 10, flex: '1 0 auto', overflow: 'auto'}}>
              {fetchedData.length > 0 && isValidated.id !== null ? <iframe style={{height: '100%', width: '100%'}} src={createPDF(isValidated.id, fetchedData, 'preview', props.user, '')}></iframe> : <p>Select a daily to preview</p>}
            </div> : null

          }

        </div> :
        <p style={{margin: 10}}>Loading...</p>

      }

    </>
  )

}

export default Dailies
